import React, { useRef, useState, useEffect, MutableRefObject, FC } from "react";
import { YhPageHeader } from "@/components/YhPageHeader";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox"
import { TableBox } from "./TableBox"
import { AddMaterialModal } from "./materialModel"
import { AddItemModal } from "./itemModel"
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { FixedBottom } from "./FixedBottom"
import { MaterialHistoryModel } from "./materialHistoryModel"
import useNavModel, { RouterParamType } from "@/model/navModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export const AppointmentDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, rolesAllList, setLocale } = useGlobalModel();
    const Locale = setLocale(LanguageArr)
    const titleType = {
        add: Locale["Add"],
        edit: Locale["Edit"],
        look: Locale["View"],

        // look: "查看",
        // add: "新增",
        // edit: "编辑",
        // look: "查看",
    }
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const IYhFormRef = useRef<IYhFormRef>();
    return (
        <div>
            {/* <YhPageHeader title={`维修单${titleType[detailsInfo.mode]}`} /> */}
            <YhPageHeader title={`${Locale["Appointment Doc"]}${'  '}${titleType[detailsInfo.mode]}`} />
            <TopButs {...detailsInfo} IYhFormRef={IYhFormRef} />
            <FormBox {...detailsInfo} IYhFormRef={IYhFormRef} />
            <TableBox {...detailsInfo} />
            <AddMaterialModal {...detailsInfo} />
            <AddItemModal {...detailsInfo} />
            <FixedBottom {...detailsInfo} />
            <MaterialHistoryModel {...detailsInfo} />
        </div>
    )
}